import './leaderboard-sort-tabs.scss';

import type { FC, SVGProps } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { LeaderboardSortBy } from '@/entities/leaderboard';
import CrownIcon from '@/shared/assets/icons/crown.svg?react';
import DollarIcon from '@/shared/assets/icons/dollar.svg?react';
import GamepadIcon from '@/shared/assets/icons/gamepad-bold.svg?react';

const SORT_ICONS: Record<LeaderboardSortBy, FC<SVGProps<SVGSVGElement>>> = {
  profit: DollarIcon,
  turnover: CrownIcon,
  games: GamepadIcon,
};

type LeaderboardSortTabsProps = {
  active: LeaderboardSortBy;
  onChange: (value: LeaderboardSortBy) => void;
};

function LeaderboardSortTabsComponent({ active, onChange }: LeaderboardSortTabsProps) {
  const { t } = useTranslation();

  const SORT_TABS: { value: LeaderboardSortBy; label: string }[] = [
    { value: 'profit', label: t('leaderboard.sortProfit') },
    { value: 'turnover', label: t('leaderboard.sortTurnover') },
    { value: 'games', label: t('leaderboard.sortGames') },
  ];

  return (
    <div className="leaderboard-sort-tabs">
      {SORT_TABS.map(({ value, label }) => {
        const SortIcon = SORT_ICONS[value];
        return (
          <button
            key={value}
            className={`leaderboard-sort-tabs__tab leaderboard-sort-tabs__tab--${value}${active === value ? ' leaderboard-sort-tabs__tab--active' : ''}`}
            onClick={() => onChange(value)}>
            <SortIcon className="leaderboard-sort-tabs__icon" />
            <span className="leaderboard-sort-tabs__label">{label}</span>
          </button>
        );
      })}
    </div>
  );
}

export const LeaderboardSortTabs = memo(LeaderboardSortTabsComponent);
